export function EmptyStateIcon() {
  return (
    <svg
      width='124'
      height='124'
      viewBox='0 0 124 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='124' height='124' rx='62' fill='#F4F6F8' />
      <rect
        x='20.9688'
        y='27.3535'
        width='82.0588'
        height='62'
        rx='1.78947'
        fill='white'
        stroke='#D3222A'
        strokeWidth='1.78947'
      />
      <rect
        x='21.2109'
        y='27.7363'
        width='81.5789'
        height='12.2368'
        fill='#B7CCE1'
      />
      <rect
        x='20.9688'
        y='27.3535'
        width='82.0588'
        height='62'
        rx='1.78947'
        stroke='#385F99'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M33.852 35.8954C34.9783 35.8954 35.8914 34.9822 35.8914 33.8559C35.8914 32.7295 34.9783 31.8164 33.852 31.8164C32.7256 31.8164 31.8125 32.7295 31.8125 33.8559C31.8125 34.9822 32.7256 35.8954 33.852 35.8954Z'
        fill='#385F99'
      />
      <path
        d='M27.3285 35.8954C28.4549 35.8954 29.368 34.9822 29.368 33.8559C29.368 32.7295 28.4549 31.8164 27.3285 31.8164C26.2022 31.8164 25.2891 32.7295 25.2891 33.8559C25.2891 34.9822 26.2022 35.8954 27.3285 35.8954Z'
        fill='#385F99'
      />
      <path
        d='M62 79.3242C70.5604 79.3242 77.5 72.3846 77.5 63.8242C77.5 55.2638 70.5604 48.3242 62 48.3242C53.4396 48.3242 46.5 55.2638 46.5 63.8242C46.5 72.3846 53.4396 79.3242 62 79.3242Z'
        fill='white'
        stroke='#385F99'
        strokeWidth='1.78947'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M44.5149 15.1967C44.5807 14.797 45.1553 14.797 45.2211 15.1966L45.4031 16.3016C45.4281 16.453 45.5467 16.5716 45.6981 16.5965L46.803 16.7785C47.2027 16.8444 47.2027 17.419 46.803 17.4848L45.6981 17.6668C45.5467 17.6918 45.4281 17.8104 45.4031 17.9618L45.2211 19.0667C45.1553 19.4663 44.5807 19.4663 44.5149 19.0667L44.3329 17.9618C44.3079 17.8104 44.1893 17.6918 44.0379 17.6668L42.933 17.4848C42.5333 17.419 42.5333 16.8444 42.933 16.7785L44.0379 16.5965C44.1893 16.5716 44.3079 16.453 44.3329 16.3016L44.5149 15.1967Z'
        fill='#385F99'
      />
      <path
        d='M111.412 51.0912C111.478 50.6915 112.053 50.6915 112.118 51.0912L112.531 53.5969C112.556 53.7483 112.675 53.867 112.826 53.8919L115.332 54.3047C115.731 54.3705 115.731 54.9451 115.332 55.0109L112.826 55.4237C112.675 55.4486 112.556 55.5673 112.531 55.7186L112.118 58.2244C112.053 58.624 111.478 58.624 111.412 58.2244L110.999 55.7186C110.974 55.5673 110.856 55.4486 110.704 55.4237L108.199 55.0109C107.799 54.9451 107.799 54.3705 108.199 54.3047L110.704 53.8919C110.856 53.867 110.974 53.7483 110.999 53.5969L111.412 51.0912Z'
        fill='#385F99'
      />
      <path
        d='M13.1103 64.9603C13.1761 64.5607 13.7507 64.5607 13.8165 64.9603L14.0562 66.4155C14.0812 66.5668 14.1998 66.6855 14.3512 66.7104L15.8063 66.9501C16.206 67.0159 16.206 67.5906 15.8063 67.6564L14.3512 67.8961C14.1998 67.921 14.0812 68.0397 14.0562 68.191L13.8165 69.6462C13.7507 70.0458 13.1761 70.0458 13.1103 69.6462L12.8706 68.191C12.8456 68.0397 12.727 67.921 12.5756 67.8961L11.1205 67.6564C10.7208 67.5906 10.7208 67.0159 11.1205 66.9501L12.5756 66.7104C12.727 66.6855 12.8456 66.5668 12.8706 66.4155L13.1103 64.9603Z'
        fill='#385F99'
      />
      <line
        x1='21.9688'
        y1='40.0293'
        x2='101.548'
        y2='40.0293'
        stroke='#385F99'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <line
          x1='27.4375'
          y1='101.117'
          x2='98.3787'
          y2='101.117'
          stroke='#E6E6E6'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <line
        x1='62.0859'
        y1='57.5293'
        x2='62.0859'
        y2='70.1175'
        stroke='#385F99'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='68.2969'
        y1='63.9121'
        x2='55.7086'
        y2='63.9121'
        stroke='#385F99'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <rect
        x='21.8828'
        y='41.0293'
        width='80.2353'
        height='1.82353'
        fill='#E6E6E6'
      />
    </svg>
  );
}
